import React, { useEffect, useState } from 'react';
import dailyCommunication from './daily_communication.webp';
import dailyCommunicationDark from './daily_communication_dark.webp';
import CardSwiper from '../../components/CardSwiper';
import Footer from '../../components/Footer';
import FAQSection from '../../components/FAQSection';
import image1 from './image1.webp';
import image1Dark from './image1_dark.webp';
import clubsImage from './clubs.webp';
import clubsImageDark from './clubs_dark.webp';
import groupChatsImage from './group_chats.webp';
import groupChatsImageDark from './group_chats_dark.webp';
import dancingDoodle from './DancingDoodle.webp';
import dancingDoodleDark from './DancingDoodle_dark.webp';
import digit1 from './digit_step_1_light.svg';
import digit2 from './digit_step_2_light.svg';
import digit3 from './digit_step_3_light.svg';
import digit4 from './digit_step_4_light.svg';
import digit1Dark from './digit_step_1_dark.svg';
import digit2Dark from './digit_step_2_dark.svg';
import digit3Dark from './digit_step_3_dark.svg';
import digit4Dark from './digit_step_4_dark.svg';
import { resolveTheme, subscribeToThemeChange } from '../../utils/theme';

function Home() {
  const [isDarkTheme, setIsDarkTheme] = useState(() => resolveTheme() === 'dark');

  useEffect(() => subscribeToThemeChange((theme) => {
    setIsDarkTheme(theme === 'dark');
  }), []);

  return (
    <div className="home">
      <main className="home-main-content">
        <section className="layout-12 mx-auto home-hero">
          <div className="home-hero__text">
            <div className="home-hero__lead">
              <span className="home-hero__asterisk">*</span>
              <span className="home-hero__lead-text">
                Найди людей, с которыми хочется общаться
              </span>
            </div>

            <h1 className="home-hero__title">
              <span className="font-bold" style={{ color: 'var(--home-brand-accent)' }}>T</span>
              <span className="font-bold" style={{ color: 'var(--home-brand-text)' }}>-Interest </span>
              — независимый сервис
              <br />
              для поиска коллег по интересам, <span style={{ whiteSpace: 'nowrap' }}>общению и совместным активностям</span>
            </h1>

            <p className="home-hero__desc">
              Без дейтинга. Без неловкости. Только живое общение и интересы
            </p>

            <div className="home-hero__cta-row">
              <form action="/log_in" method="get" className="w-auto">
                <button
                  type="submit"
                  className="home-hero__cta-btn"
                >
                  Подобрать людей по интересам
                </button>
              </form>
              <span className="home-hero__cta-note">
                Это займёт 2-3 минуты
              </span>
            </div>
          </div>

          <div className="home-hero__image-wrap">
            <img
              src={isDarkTheme ? image1Dark : image1}
              alt="Карточка пользователя"
              className="home-hero__image"
              decoding="async"
            />
          </div>
        </section>

        <div className="home-gap-100 home-gap-hero-swiper" />

        <CardSwiper
          cards={[
            { id: 1, img: require('./1.webp'), text: 'Ты новичок и не знаешь,\nс кем общаться' },
            { id: 2, img: require('./2.webp'), text: 'Хочешь найти людей\nдля спорта, игр или хобби' },
            { id: 3, img: require('./3.webp'), text: 'Нужны живые разговоры,\nа не только рабочие чаты' },
            { id: 4, img: require('./4.webp'), text: 'Ищешь команду для\nстартапа или хакатона' },
            { id: 5, img: require('./5.webp'), text: 'Хочешь расширить круг общения без неловкости' },
          ]}
        />

        <div className="home-gap-100 home-gap-swiper-to-offers" />

        <div className="layout-12 mx-auto pb-0 md:pb-0">
          <h2 className="section-title-main home-offers-title home-title-gap home-offers-title-gap flex items-center justify-center text-center md:justify-start md:text-left">
            Что мы предлагаем
          </h2>
          <div className="home-offers-grid">
            <div className="home-offer-card home-offer-card--wide group">
              <img src={isDarkTheme ? dancingDoodleDark : dancingDoodle} alt="Новые знакомства" className="absolute inset-0 h-full w-full pointer-events-none object-contain object-left-top" loading="lazy" decoding="async" />
              <div className="home-offer-copy home-offer-copy--right home-offer-copy--acquaintance">
                <h3 className="offer-card-title mb-0 text-right">Новые знакомства</h3>
                <p className="offer-card-desc text-right md:mt-1">
                  <span className="block whitespace-nowrap">Подбор людей по общим интересам,</span>
                  <span className="block whitespace-normal xl:whitespace-nowrap">а не случайным совпадениям</span>
                </p>
              </div>
            </div>

            <div className="home-offer-card home-offer-card--narrow">
              <div className="home-offer-copy home-offer-copy--left home-offer-copy--live">
                <h3 className="offer-card-title mb-0">Живое общение</h3>
                <p className="offer-card-desc md:mt-1">
                  <span className="block whitespace-normal xl:whitespace-nowrap">Диалоги один на один</span>
                  <span className="block whitespace-normal xl:whitespace-nowrap">и без формальностей</span>
                </p>
              </div>
              <div className="absolute inset-0 h-full w-full">
                <img src={isDarkTheme ? dailyCommunicationDark : dailyCommunication} alt="Живое общение" className="h-full w-full object-contain object-right-top" loading="lazy" decoding="async" />
              </div>
            </div>

            <div className="home-offer-card home-offer-card--narrow order-last md:order-none">
              <div className="home-offer-copy home-offer-copy--left home-offer-copy--clubs">
                <h3 className="offer-card-title mb-0 whitespace-normal xl:whitespace-nowrap">Клубы по интересам</h3>
                <p className="offer-card-desc md:mt-1">
                  <span className="block whitespace-nowrap">Создавай свои сообщества или</span>
                  <span className="block whitespace-nowrap">вступай в существующие</span>
                </p>
              </div>
              <div className="absolute inset-0 h-full w-full">
                <img src={isDarkTheme ? clubsImageDark : clubsImage} alt="Клубы по интересам" className="h-full w-full object-contain object-right-top pointer-events-none" loading="lazy" decoding="async" />
              </div>
            </div>

            <div className="home-offer-card home-offer-card--wide">
              <div className="absolute inset-0 h-full w-full">
                <img src={isDarkTheme ? groupChatsImageDark : groupChatsImage} alt="Групповые чаты" className="h-full w-full object-contain object-left-top" loading="lazy" decoding="async" />
              </div>
              <div className="home-offer-copy home-offer-copy--right home-offer-copy--group">
                <h3 className="offer-card-title mb-0 text-right">Групповые чаты</h3>
                <p className="offer-card-desc text-right md:mt-1">
                  <span className="block whitespace-normal xl:whitespace-nowrap">Общайся сразу с несколькими</span>
                  <span className="block whitespace-normal xl:whitespace-nowrap">людьми по одной теме</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="home-gap-100 home-gap-offers-to-steps" />

        <div className="home-steps-section pb-10" style={{ backgroundColor: 'var(--home-card-bg)' }}>
          <div className="layout-12 mx-auto">
            <h2 className="section-title-main home-title-gap home-steps-title flex justify-center text-center md:justify-start md:text-left">
              Всего несколько шагов{' '}
              <br className="md:hidden" />
              до живого общения
            </h2>

            <div className="home-steps-list relative space-y-8 md:space-y-8 xl:space-y-0" style={{ height: 'var(--home-steps-height-xl)' }}>
              <div className="home-step-item flex flex-row items-center relative z-10 xl:absolute xl:left-0 xl:top-0">
                <div className="home-step-icon-wrap flex-shrink-0 mr-4 md:mr-6 mb-0">
                  <img src={isDarkTheme ? digit1Dark : digit1} alt="1" className="home-step-icon object-contain" loading="lazy" decoding="async" style={{ width: 'var(--home-step-icon-size)', height: 'var(--home-step-icon-size)' }} />
                </div>
                <div className="home-step-text pt-0 flex flex-col justify-center">
                  <h3 className="home-step-heading font-tt-norms font-bold" style={{ color: 'var(--home-title)' }}>Расскажи о себе</h3>
                  <p className="home-step-desc font-light" style={{ color: 'var(--home-step-text)' }}>Укажи интересы, хобби и формат общения</p>
                </div>
              </div>

              <div className="hidden xl:block absolute xl:left-0 z-0" style={{ top: 'var(--home-step-icon-size)' }}>
                <svg className="home-step-arrow" viewBox="0 0 150 173" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M60 0L60 95Q60 110 77 110L140 110" stroke="var(--home-step-arrow)" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                  <path d="M145 110L120 80" stroke="var(--home-step-arrow)" strokeWidth="8" strokeLinecap="round" fill="none" />
                  <path d="M145 110L120 140" stroke="var(--home-step-arrow)" strokeWidth="8" strokeLinecap="round" fill="none" />
                </svg>
              </div>

              <div className="home-step-item flex flex-row items-center relative z-10 xl:absolute" style={{ left: 'var(--home-steps-item-2-left)', top: 'var(--home-steps-item-2-top)' }}>
                <div className="home-step-icon-wrap flex-shrink-0 mr-4 md:mr-6 mb-0">
                  <img src={isDarkTheme ? digit2Dark : digit2} alt="2" className="home-step-icon object-contain" loading="lazy" decoding="async" style={{ width: 'var(--home-step-icon-size)', height: 'var(--home-step-icon-size)' }} />
                </div>
                <div className="home-step-text pt-0 flex flex-col justify-center">
                  <h3 className="home-step-heading font-tt-norms font-bold" style={{ color: 'var(--home-title)' }}>Получи персональные рекомендации</h3>
                  <p className="home-step-desc font-light" style={{ color: 'var(--home-step-text)' }}>Мы подберём людей, которые тебе реально подходят</p>
                </div>
              </div>

              <div className="hidden xl:block absolute z-0" style={{ left: 'var(--home-steps-item-2-left)', top: 'calc(var(--home-steps-item-2-top) + var(--home-step-icon-size))' }}>
                <svg className="home-step-arrow" viewBox="0 0 150 173" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M60 0L60 95Q60 110 77 110L140 110" stroke="var(--home-step-arrow)" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                  <path d="M145 110L120 80" stroke="var(--home-step-arrow)" strokeWidth="8" strokeLinecap="round" fill="none" />
                  <path d="M145 110L120 140" stroke="var(--home-step-arrow)" strokeWidth="8" strokeLinecap="round" fill="none" />
                </svg>
              </div>

              <div className="home-step-item flex flex-row items-center relative z-10 xl:absolute" style={{ left: 'var(--home-steps-item-3-left)', top: 'var(--home-steps-item-3-top)' }}>
                <div className="home-step-icon-wrap flex-shrink-0 mr-4 md:mr-6 mb-0">
                  <img src={isDarkTheme ? digit3Dark : digit3} alt="3" className="home-step-icon object-contain" loading="lazy" decoding="async" style={{ width: 'var(--home-step-icon-size)', height: 'var(--home-step-icon-size)' }} />
                </div>
                <div className="home-step-text pt-0 flex flex-col justify-center">
                  <h3 className="home-step-heading font-tt-norms font-bold" style={{ color: 'var(--home-title)' }}>Выбери тех, кто откликнулся</h3>
                  <p className="home-step-desc font-light" style={{ color: 'var(--home-step-text)' }}>Просматривай профили и интересы</p>
                </div>
              </div>

              <div className="hidden xl:block absolute z-0" style={{ left: 'var(--home-steps-item-3-left)', top: 'calc(var(--home-steps-item-3-top) + var(--home-step-icon-size))' }}>
                <svg className="home-step-arrow" viewBox="0 0 150 173" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M60 0L60 95Q60 110 77 110L140 110" stroke="var(--home-step-arrow)" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                  <path d="M145 110L120 80" stroke="var(--home-step-arrow)" strokeWidth="8" strokeLinecap="round" fill="none" />
                  <path d="M145 110L120 140" stroke="var(--home-step-arrow)" strokeWidth="8" strokeLinecap="round" fill="none" />
                </svg>
              </div>

              <div className="home-step-item flex flex-row items-center relative z-10 xl:absolute" style={{ left: 'var(--home-steps-item-4-left)', top: 'var(--home-steps-item-4-top)' }}>
                <div className="home-step-icon-wrap flex-shrink-0 mr-4 md:mr-6 mb-0">
                  <img src={isDarkTheme ? digit4Dark : digit4} alt="4" className="home-step-icon object-contain" loading="lazy" decoding="async" style={{ width: 'var(--home-step-icon-size)', height: 'var(--home-step-icon-size)' }} />
                </div>
                <div className="home-step-text pt-0 flex flex-col justify-center">
                  <h3 className="home-step-heading font-tt-norms font-bold" style={{ color: 'var(--home-title)' }}>Начни диалог</h3>
                  <p className="home-step-desc font-light" style={{ color: 'var(--home-step-text)' }}>Пиши первым и находи свою компанию</p>
                </div>
              </div>
            </div>

            <div className="home-steps-cta-gap flex justify-center md:justify-end">
              <form action="/log_in" method="get" className="home-steps-cta-form w-full md:w-auto">
                <button className="home-steps-select-btn">
                  Начать подбор
                </button>
              </form>
            </div>
          </div>
        </div>
      </main>

      <FAQSection />
      <Footer />
    </div>
  );
}

export default Home;
